import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import { useState } from "react";

interface RejectReasonModalProps {
    authorName?: string;
}

function RejectReasonModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<RejectReasonModalProps>) {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Vui lòng nhập lý do từ chối");

      return;
    }

    portalDialogRef.close({ isAccept: true, reason: reason });
  };

  const title = portalData?.authorName
    ? "Từ chối liên kết ngân hàng"
    : "Từ chối yêu cầu";

  const message = portalData?.authorName
    ? `Bạn có chắc chắn muốn từ chối liên kết ngân hàng của ${portalData.authorName}?`
    : "Bạn có chắc chắn muốn từ chối yêu cầu này?";

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="w-[500px] py-7 px-6">
        <div className="text-xl text-center font-semibold">
          {title}
        </div>
        <div className="mt-4 text-center text-[#83898C]">
          {message}
        </div>
        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
                        Lý do từ chối <span className="text-red-500">*</span>
          </label>
          <textarea
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[100px]"
            placeholder="Nhập lý do từ chối..."
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              setError("");
            }}
          />
          {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
        </div>
        <div className="mt-8 flex justify-center gap-4">
          <Button
            size="xs"
            label="Hủy"
            theme="secondary"
            width={180}
            className="!h-[51px] !leading-[51px]"
            onClick={portalDialogRef.close}
          />
          <Button
            size="xs"
            label="Xác nhận"
            width={180}
            className="!h-[51px] !leading-[51px]"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
}

export default RejectReasonModal;
